export default __webpack_public_path__ + "static/media/lupax.dc7183ca.png";